import { useNavigateToKind } from './useNavigateToKind'

/**
 * Returns a navigateToSection callback that focuses the canvas on a single
 * Section, hiding every other top-level entity - the Section equivalent of
 * useNavigateToFrame.
 */
export function useNavigateToSection() {
  return useNavigateToKind('section')
}
